import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'found';
import appStyles from '../../App/App.scss';
import styles from '../Financial.scss';
import { Grid, Label, Loader, Segment } from 'semantic-ui-react';
import currencyFormatter from 'currency-formatter';
import InvoiceListHeader from './InvoiceListHeader';
import Waypoint from 'react-waypoint';

const InvoiceList = class InvoiceList extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.getLabel = this.getLabel.bind(this);
    this.transition = this.transition.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.state = {
      loading: false,
      listSize: 20,
      showSearch: false
    };
  }

  getLabel(status) {
    switch (status) {
      case 'paid':
        return { color: 'black', text: 'Paid' };
      case 'past_due':
        return { color: 'red', text: 'Past Due' };
      default:
        return { color: null, text: 'Outstanding' };
    }
  }

  loadMore() {
    if (this.props.relay.hasMore() && !this.state.loading) {
      this.props.relay.loadMore(20, () => {
        this.setState({ loading: false, listSize: this.state.listSize + 20 });
      });
      this.setState({ loading: true });
    }
  }

  transition(to) {
    this.props.router.push(to);
  }

  render() {
    const { invoices } = this.props.viewer;
    const { query } = this.props.location;
    const currency = 'USD';
    const statusMappings = {
      ALL: '',
      OUTSTANDING: 'outstanding',
      PAID: 'paid',
      PAST_DUE: 'past due'
    };

    return (
      <div>
        <Segment className={appStyles.segmentContainer}>
          <InvoiceListHeader />
          <Grid>
            {invoices.edges.map(invoice =>
              [
                <Grid.Row
                  only='mobile'
                  onClick={this.transition.bind(null, `/docs/i/${invoice.node.id}`)}
                  key={`${invoice.node.id}_mobile`}
                  className={styles.tableRow}
                >
                  <Grid.Column width={16}>
                    <div style={{ display: 'flex' }}>
                      <div style={{ flex: 1 }}>
                        <strong>{invoice.node.title}</strong>
                        <div className={styles.eventTitleMobile}>
                          {invoice.node.workspaces.edges[0].node.event.title}
                        </div>
                        <div className={styles.paymentSummary}>
                        {currencyFormatter.format(
                          invoice.node.outstanding_cents / 100,
                          { code: currency }
                        )} remaining &nbsp;/ &nbsp;
                        {currencyFormatter.format(
                          invoice.node.total_cents / 100,
                          { code: currency }
                        )}
                        </div>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <Label
                          style={{ marginTop: '0.5em' }}
                          basic
                          color={this.getLabel(invoice.node.status).color}
                          size='small'
                        >
                          {this.getLabel(invoice.node.status).text}
                        </Label>
                      </div>
                    </div>
                  </Grid.Column>
                </Grid.Row>,
                <Grid.Row
                  onClick={this.transition.bind(null, `/docs/i/${invoice.node.id}`)}
                  className={styles.tableRow}
                  only='computer tablet'
                  key={`${invoice.node.id}_computer`}
                >
                  <Grid.Column width={6}>
                    <div>
                      <strong>
                        {invoice.node.title}
                      </strong>
                    </div>
                    <div className={styles.mutedText}>
                      {invoice.node.workspaces.edges[0].node.event.title}
                    </div>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Label
                      basic
                      color={this.getLabel(invoice.node.status).color}
                    >
                      {this.getLabel(invoice.node.status).text}
                    </Label>
                  </Grid.Column>
                  <Grid.Column width={3} textAlign='right'>
                    {currencyFormatter.format(
                      invoice.node.total_cents / 100,
                      { code: currency }
                    )}
                  </Grid.Column>
                  <Grid.Column width={3} textAlign='right'>
                    {currencyFormatter.format(
                      invoice.node.outstanding_cents / 100,
                      { code: currency }
                    )}
                  </Grid.Column>
                </Grid.Row>]
            )}
            {invoices.edges.length === 0 &&
              <Grid.Row columns='equal'>
                <Grid.Column>
                  <h4 style={{ textAlign: 'center', margin: '2em' }}>
                    You have no {statusMappings[query.status]} invoices
                  </h4>
                </Grid.Column>
              </Grid.Row>
            }
          </Grid>
        </Segment>
        <Waypoint onEnter={this.loadMore} bottomOffset={-200} />
        {this.props.relay.hasMore() &&
          this.state.loading &&
          <div style={{ marginBottom: '2em', textAlign: 'center' }}>
            <Loader
              active
              inline
              size='tiny'
              style={{ marginRight: '1em' }}
            />{' '}
            Loading More...
          </div>
        }
      </div>
    );
  }
};

export default withRouter(InvoiceList);



// WEBPACK FOOTER //
// ./webpack/components/Financial/Invoices/InvoiceList.js